<template>
    <div class="container-fluid" v-if="tracker && posicao">

        <header-admin :rastreador="tracker" :posicao="posicao" :veiculo="veiculo"></header-admin>

        <vk-tabs :keep-alive="true">

            <vk-tabs-item title="INICIAL">
                <positions-maps :posicao="posicao"/>
            </vk-tabs-item>

            <vk-tabs-item title="COMANDOS" v-if="rastreador">
                <div class="col-sm-3">
                    <enviar-saidas :id_rastreador="rastreador.id_rastreador"/><br/>
                    <reset :id_rastreador="rastreador.id_rastreador"/><br/>
                    <solicitar-configuracao :id_rastreador="rastreador.id_rastreador"/>
                </div>

                <div class="col-sm-9">
                    <table-comandos :id_rastreador="rastreador.id_rastreador"/>
                </div>

            </vk-tabs-item>

            <vk-tabs-item title="PROBLEMAS" v-if="veiculo && ! isMobile()">
                <problemas  @reload="loadVeiculo($event)" :veiculo="veiculo"></problemas>
            </vk-tabs-item>

            <vk-tabs-item title="CLIENTE" v-if="cliente">
                <dados-do-cliente-admin :cliente="cliente"/>
            </vk-tabs-item>

            <vk-tabs-item title="VEÍCULO" v-if="veiculo">
                <dados-do-veiculo-admin :veiculo="veiculo"/>
            </vk-tabs-item>

            <vk-tabs-item title="RELATÓRIOS" v-if="veiculo && ! isMobile()">
                <dados-relatorios-admin :veiculo="veiculo"/>
            </vk-tabs-item>

            <vk-tabs-item title="CONFIGURAÇÃO" v-if="config">
                <div v-if="config" style="margin-bottom: 10px">IMEI: <b>{{config.imei}}</b></div>
                <vue-tabs>
                    <v-tab title="COMANDO LIVRE" >
                        <br/>
                        <comando-livre :id_rastreador="rastreador.id_rastreador"/>
                    </v-tab>

                    <v-tab title="CONEXAO" v-if="config">
                        <br/>
                        <conexao :config="config"/>
                    </v-tab>

                    <v-tab title="TEMPOS" v-if="config">
                        <br/>
                        <tempos :config="config"/>
                    </v-tab>

                    <v-tab title="EVENTOS" v-if="config">
                        <br/>
                        <eventos :config="config"/>
                    </v-tab>

                    <v-tab title="HODOMETRO">
                        <br/>
                        <ajustar-hodometro :id_rastreador="rastreador.id_rastreador"/>
                    </v-tab>

                    <v-tab title="HORIMETRO">
                        <br/>
                        <ajustar-horimetro :id_rastreador="rastreador.id_rastreador"/>
                    </v-tab>

                    <v-tab title="NOVOS PARAMETROS">
                        <br/>
                        <novas-configuracoes :config="config"/>
                    </v-tab>

                    <v-tab title="SERVIÇOS">
                        <br/>
                        <servicos :config="config"/>
                    </v-tab>

                    <v-tab title="TENSÃO">
                        <br/>
                        <tensao :config="config"/>
                    </v-tab>

                    <v-tab title="ACELERÔMETRO">
                        <br/>
                        <acelerometro :config="config"/>
                    </v-tab>
                </vue-tabs>
            </vk-tabs-item>

        </vk-tabs>

    </div>
    <div class="container-fluid" v-else>
        <center>
            <h1>Aguardando dados e primeira transmissão</h1>
        </center>
        <vk-tabs :keep-alive="true">
            <vk-tabs-item title="COMANDOS" v-if="rastreador">
                <div class="col-sm-3">
                    <enviar-saidas :id_rastreador="rastreador.id_rastreador"/><br/>
                    <reset :id_rastreador="rastreador.id_rastreador"/><br/>
                    <solicitar-configuracao :id_rastreador="rastreador.id_rastreador"/>
                </div>

                <div class="col-sm-9">
                    <table-comandos :id_rastreador="rastreador.id_rastreador"/>
                </div>

            </vk-tabs-item>
        </vk-tabs>
    </div>
</template>
<script>
    import MenuSuperior from '../../components/MenuSuperior.vue';
    import EnviarSaidas from '../../components/buttons/EnviarSaidas';
    import {Rastreador, Suntech, Veiculo} from "../../class";
    import AjustarHodometro from './partials/AjustarHodometro.vue';
    import SolicitarConfiguracao from '../../components/buttons/SolicitarConfiguracao.vue';
    import Conexao from './partials/suntech/Conexao.vue';
    import Tempos from './partials/suntech/Tempos';
    import Eventos from './partials/suntech/Eventos';
    import NovasConfiguracoes from './partials/suntech/NovasConfiguracoes';
    import Servicos from './partials/suntech/Servicos';
    import Tensao from './partials/suntech/Tensao';
    import HeaderAdmin from './HeaderAdmin';
    import AjustarHorimetro from "./partials/AjustarHorimetro.vue";
    import Problemas from "../veiculo/Problemas";
    import TableComandos from "../tables/TableComandos";
    import Reset from "../buttons/Reset";
    import {veiculosAdminMixins} from './partials/veiculo-admin-mixins';
    import PositionsMaps from './partials/PositionsMaps.vue';
    import Acelerometro from './partials/suntech/Acelerometro.vue';
    import DadosRelatoriosAdmin from './partials/DadosRelatoriosAdmin.vue';
    import DadosDoClienteAdmin from './partials/DadosDoClienteAdmin.vue';
    import DadosDoVeiculoAdmin from './partials/DadosDoVeiculoAdmin.vue';
    import {isMobile} from '../../utils/is-celular';
    import ComandoLivre from './partials/generico/ComandoLivre.vue';

    export default {
        methods: {
            isMobile() {
                return isMobile()
            }
        },
        components: {
            ComandoLivre,
            DadosDoVeiculoAdmin,
            DadosDoClienteAdmin,
            DadosRelatoriosAdmin,
            Acelerometro,
            PositionsMaps,
            Problemas,
            AjustarHorimetro,
            HeaderAdmin,
            MenuSuperior, Reset, TableComandos,
            SolicitarConfiguracao, Conexao, EnviarSaidas, AjustarHodometro,
            Tempos, Eventos, NovasConfiguracoes, Servicos, Tensao
        },

        mixins: [
            veiculosAdminMixins
        ],

        data(){
            return {
                config: null
            }
        },

        async beforeMount(){
            this.config = await Suntech.byPK(this.rastreador.id_rastreador);
        },

    }
</script>
